import { css } from 'lit-element';

// new style for CKEDITOR content
export const ckEditorStyleOverride = css`
  .ck-editor-content {
    line-height: 1.42857;
    @include clearfix;

    & h1,
    & h2,
    & h3,
    & h4,
    & h5,
    & h6 {
      font-weight: 450;
      line-height: 1.42857;
    }

    & h1 {
      margin-top: 20px;
      margin-bottom: 10px;
      font-size: 3.2rem; // ~32px
    }

    & h2 {
      margin-top: 20px;
      margin-bottom: 10px;
      font-size: 2.5rem; // ~25px
    }

    & h3 {
      margin-top: 20px;
      margin-bottom: 10px;
      font-size: 2rem; // ~20px
    }

    & h4 {
      margin: 10px 0;
      font-size: 1.8rem; // ~18px
    }

    & h5 {
      margin: 10px 0;
      font-size: 1.6rem; // ~16px
    }

    & h6 {
      margin: 10px 0;
      font-size: 1.4rem; // ~14px
    }

    & p {
      margin: 10px 0;
      font-size: 1.4rem; // ~14px
    }

    & ul,
    & ol {
      font-size: 1.4rem; // ~14px
      list-style-position: outside;
    }

    & li,
    & ol {
      font-size: 1.4rem; // ~14px
    }

    & li + li {
      margin-top: 12px;
    }

    & blockquote {
      margin: 1em 40px;
      padding: 1px 8px 1px 20px;
      font-family: 'Inter var', sans-serif;
      font-size: 1.6rem;
      font-style: italic;
      border-color: #969696;

      & p {
        margin: 1em 0;
      }
    }

    & img {
      max-width: 100%;
      height: auto;
    }

    // Custom override for code block (<pre> tag)
    code {
      padding: 2px 4px;
      font-size: 90%;
      color: #c7254e;
      background-color: #f9f2f4;
      border-radius: 4px;
    }

    // @@ MOBILES BREAK POINT MAX-WIDTH:480px
    @media (max-width: 480px) {
      .ck-editor-content {
        & p {
          font-size: 1.4rem;
        }

        & li,
        & ol {
          font-size: 1.4rem;
        }

        & blockquote {
          font-size: 1.4rem;
        }
      }
    }
  }
`;
